/*
 *
 * EditorLists actions
 *
 */
import { createAction } from 'redux-actions';
import {
  PROCESSING,
  CREATE_LIST,
  CREATE_LIST_RESULT,
  GET_LISTS,
  GET_LISTS_RESULT,
  DELETE_LIST,
  DELETE_LIST_SUCCESS,
  DELETE_LIST_FAIL,
  RENAME_LIST,
  RENAME_LIST_SUCCESS,
  RENAME_LIST_FAIL,
} from './constants';

export const processing = createAction(PROCESSING);
export const createList = createAction(CREATE_LIST);
export const createListResult = createAction(CREATE_LIST_RESULT);
export const getLists = createAction(GET_LISTS);
export const getListsResult = createAction(GET_LISTS_RESULT);
export const deleteList = createAction(DELETE_LIST);
export const deleteListSuccess = createAction(DELETE_LIST_SUCCESS);
export const deleteListFail = createAction(DELETE_LIST_FAIL);
export const renameList = createAction(RENAME_LIST);
export const renameListSuccess = createAction(RENAME_LIST_SUCCESS);
export const renameListFail = createAction(RENAME_LIST_FAIL);
